import Application from './ApplicationContainer';

export default Application;
